/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClusterAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 5a3 3 0 1 1 4 2.83v3.756l4.707 4.706a3 3 0 1 1-1.414 1.414L12 13.415l-4.292 4.293a3 3 0 1 1-1.414-1.414L11 11.585V7.829A3.001 3.001 0 0 1 9 5zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm13 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgClusterAlt as ClusterAlt };
